import { __assign } from "tslib";
import { useContext } from 'react';
import { RumComponentContext } from './rum-component-context';
import { getGlobalObject } from '../utils/getGlobalObject';
/**
 * Utility to track errors in RUM with the component chain/breadcrumbs from <RumComponentContextProvider> automatically added
 *
 */
export var useRumError = function () {
    var componentContext = useContext(RumComponentContext);
    var RumGlobal = getGlobalObject().DD_RUM;
    if (!RumGlobal) {
        console.warn('@datadog/rum-react-integration: Datadog RUM SDK is not initialized.');
        return function () { };
    }
    return function (error, customAttributes, source) {
        var _a;
        RumGlobal.addError(error, __assign(__assign(__assign({}, componentContext.customAttributes), customAttributes), { react: __assign({ breadcrumbs: componentContext.componentBreadCrumbs, component: componentContext.component }, (_a = customAttributes) === null || _a === void 0 ? void 0 : _a.react) }), source);
    };
};
//# sourceMappingURL=use-rum-error.js.map